import Vue from 'vue';
import Vuex from 'vuex';

import I18nStore from "@/store/modules/i18n";
import Auth from "@/store/modules/auth";
import build from '../../build'
import {getters} from "@/store/getter";
import {actions} from "@/store/actions";
import {mutations} from "@/store/mutations";

Vue.use(Vuex);

export default new Vuex.Store({
  strict: true,
  state: {
    isLoading: false,
    build: build
  },
  modules: {
    auth: Auth,
    i18n: I18nStore
  },
  getters,
  actions,
  mutations
})
